import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { generatePath, useHistory } from 'react-router';
import { IApiLoyaltyProgramParticipantUserInfo } from '@api/services/user/loyaltyProgram/loyaltyProgramParticipantUser.apiService.interface';
import { Dropdown } from '@components-library/Dropdown/Dropdown';
import { LoyaltyProgramHeaderPointsItem } from '@components-member/Pages/LoyaltyProgram/LoyaltyProgramHeaderPoints/LoyaltyProgramHeaderPointsItem';
import { EnumUserRoute } from '@components-member/userRoutes/enums';
import { keyMap } from '@locales/lokalise/keyMap';
import styles from './loyaltyProgramHeaderPoints.styles.module.scss';

export const LoyaltyProgramHeaderPointsDropdown = ({ info }: { info: IApiLoyaltyProgramParticipantUserInfo[] }) => {
  const { i18n } = useTranslation();
  const history = useHistory();
  const [currentLoyaltyProgram, setCurrentLoyaltyProgram] = useState<IApiLoyaltyProgramParticipantUserInfo>(info[0]);

  const handleSelect = (key: string) => {
    const selectedLoyaltyProgram = info.find((lp) => lp.programId === Number(key));

    if (selectedLoyaltyProgram) {
      setCurrentLoyaltyProgram(selectedLoyaltyProgram);

      history.replace(
        generatePath(EnumUserRoute.loyaltyProgramDetailsPage, {
          loyaltyProgramId: selectedLoyaltyProgram.programId,
        }),
        {
          redirectedBySingleRecord: false,
        },
      );
    }
  };

  const options = info.map((item) => ({
    label: (
      <LoyaltyProgramHeaderPointsItem
        nameClassName={styles.dropdownName}
        pointsClassName={styles.dropdownPoints}
        loyaltyProgramPoints={item.points}
        loyaltyProgramName={item.name}
        wrapperClassName={styles.dropdownItem}
      />
    ),
    key: item.programId,
  }));

  return (
    <div>
      <Dropdown
        buttonClassName={styles.button}
        classNameRoot={styles.dropdown}
        selectable={false}
        onSelect={({ key }) => handleSelect(key)}
        options={options}>
        <LoyaltyProgramHeaderPointsItem
          loyaltyProgramName={`${i18n.t(keyMap.loyaltyProgramLoyaltyPoints)}:`}
          loyaltyProgramPoints={currentLoyaltyProgram.points}
          pointsClassName={styles.points}
          nameClassName={styles.name}
          wrapperClassName={styles.item}
        />
      </Dropdown>
    </div>
  );
};
